export const formatToPercentage = (value: number, compact = false): string =>
  value.toLocaleString(undefined, {
    style: "percent",
    maximumFractionDigits: compact ? 0 : 2,
  });
